export enum StronaStartowaActionType {
  KLIKNIETO_ROZPOCZNIJ = '[Strona startowa] Kliknieto rozpocznij',
  KLIKNIETO_ROZPOCZNIJ_SUCCESS = '[Strona startowa] Rozpoczeto samoobsluge',
 }
